import api from './client';

export interface FieldDef {
  key: string;
  label: string;
  field_type: 'text' | 'select' | 'tags' | 'number';
  required: boolean;
  options: string[];
  placeholder: string;
}

export interface ProductType {
  id: number;
  name: string;
  fields: FieldDef[];
  sort_order: number;
  is_active: boolean;
}

export interface TypePayload {
  name: string;
  fields: FieldDef[];
  sort_order?: number;
  is_active?: boolean;
}

export const getProductTypeCatalog = (): Promise<ProductType[]> =>
  api.get<ProductType[]>('/product-type-catalog').then((r: { data: ProductType[] }) => r.data);

export const createProductType = (data: TypePayload): Promise<ProductType> =>
  api.post<ProductType>('/product-type-catalog', data).then((r: { data: ProductType }) => r.data);

export const updateProductType = (id: number, data: Partial<TypePayload>): Promise<ProductType> =>
  api.put<ProductType>(`/product-type-catalog/${id}`, data).then((r: { data: ProductType }) => r.data);

export const deleteProductType = (id: number): Promise<void> =>
  api.delete(`/product-type-catalog/${id}`).then(() => undefined);
